<template>
  <div class="narrowContainer">
    <LoginAndRegister :action="action" :redirect="redirect"></LoginAndRegister>
  </div>
</template>

<script>
import LoginAndRegister from "../components/LoginAndRegister.vue";

export default {
  name: "Login",
  components: {
    LoginAndRegister
  },
  props: {
    action: {
      type: String,
      required: false,
      default: "login"
    },
    redirect: {
      type: String,
      required: false,
      default: "/"
    }
  }
};
</script>
